/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Fragment } from "react"

import { Flex, Tooltip } from "@mantine/core"
import { Button } from "@quorumus/plum"
import { Icon } from "@/components/Icon"
import { AdderButton } from "@/components/CardSquare/AdderButton"
import { DropdownSelect } from "@/components/CardSquare/DropdownSelect"

import classes from "@/components/CardSquare/CardSquare.module.css"

export const CardSquare = ({
    adderComponent,
    adderType,
    borderColor,
    imageUrl,
    imageUrlOnError,
    contentLines,
    footerButtons,
    footerSelects,
    name,
    onClick,
    publicOrgDescriptor,
}) => (
    <div className={classes.cardSquareOuterContainer}>
        <div className={classes.cardSquareContainer}>
            <Flex className={classes.mainContainer} direction="column" gap="1rem" onClick={onClick}>
                <Flex direction="row" gap="1.25rem">
                    <div className={classes.imageContainer} style={borderColor && { borderColor }}>
                        <img
                            alt={`${name}'s profile picture`}
                            className={classes.image}
                            height="110"
                            onError={imageUrlOnError}
                            src={imageUrl}
                            width="100"
                        />
                    </div>
                    <Flex direction="column" justify="center">
                        {/* this is a regular button for accessibility purposes */}
                        <button
                            className={classes.name}
                            onClick={(e) => {
                                e.stopPropagation()
                                onClick(e)
                            }}
                        >
                            {name}
                        </button>
                        <div>{publicOrgDescriptor}</div>
                    </Flex>
                </Flex>
                <Flex direction="column" gap=".5rem">
                    {contentLines.map((item, index) => (
                        <div className={classes.contentLine} key={`line-item-${index}`}>
                            <Icon icon={item.fa5Icon} iconFamily="fal" />
                            <div>{item.value}</div>
                        </div>
                    ))}
                </Flex>
            </Flex>
            <Flex align="center" className={classes.footerContainer} gap=".5rem" justify="space-between" wrap="wrap">
                <Flex gap=".375rem">
                    {footerSelects?.map((select, index) => (
                        <Tooltip label={select.tip_text} key={`select-${index}`}>
                            <DropdownSelect
                                icon={select.fa5_icon}
                                label={select.label}
                                options={[...select.menuOptions]}
                            />
                        </Tooltip>
                    ))}
                </Flex>
                <Flex gap=".25rem">
                    {footerButtons?.map((button, index) => (
                        <Fragment key={`button-${index}`}>
                            {["issues", "lists"].some((text) => button.tip_text.toLowerCase().includes(text)) ? (
                                <AdderButton
                                    adderComponent={adderComponent}
                                    adderType={adderType}
                                    icon={button.fa5_icon}
                                    label={button.tip_text}
                                    onClick={button.callback}
                                />
                            ) : (
                                <Tooltip label={button.tip_text}>
                                    <Button variant="tertiary" onClick={button.callback} {...button}>
                                        <Icon icon={button.fa5_icon} iconFamily="far" />
                                    </Button>
                                </Tooltip>
                            )}
                        </Fragment>
                    ))}
                </Flex>
            </Flex>
        </div>
    </div>
)
